import { array, arrayOf, func, object, shape, string } from "prop-types";
import { PureComponent } from "react";
import { connect } from "react-redux";
import createCachedSelector from "re-reselect";
import {
  getConfiguratorSubLineItems,
  getConfiguratorTemplateParams,
  getConfiguratorViews,
  getProjectBranding
} from "shared/selectors";

class ConfiguratorImage extends PureComponent {
  paramsToImageURL = params => {
    const { glencoeURL } = this.props;
    const basePath = `${glencoeURL}/combine`;
    const query = `?${Object.keys(params)
      .sort()
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&")}`;
    return basePath + query;
  };

  render() {
    const {
      children,
      optionsForImageUrl,
      view,
      selectedSubLineItem,
      templateParams
    } = this.props;
    const params = { ...view.defaultImages };
    /**
     * you can define template wide params to be passed to the configurator
     * "source_id" is the id of the root template (Raumbuchvorlage) from which the roombook is derived.
     * "params" hold name => value pairs that were added to the image URL
     *
     * "templateParams": [
     *  {
     *   "source_id": 4711,
     *   "params": [
     *     {
     *       "name": "foo",
     *       "value": "FOO_01_01"
     *     },
     *     {
     *       "name": "bar",
     *       "value": "BAR_01_01"
     *     }
     *   ]
     *  }
     * ]
     */
    templateParams.forEach(param => {
      params[[param.name]] = param.value;
    });
    const prefetchParams = { ...params };
    optionsForImageUrl.forEach(option => {
      if (option) {
        const { category, imageId } = option;
        if (imageId && view.productCategories.includes(category)) {
          params[category] = imageId;
          if (
            selectedSubLineItem &&
            !selectedSubLineItem.options.some(
              subLineItemOption =>
                option.id === subLineItemOption.id &&
                option.subLineItemId === subLineItemOption.subLineItemId
            )
          )
            prefetchParams[category] = imageId;
        }
      }
    });
    const imageURL = this.paramsToImageURL(params);

    const prefetchImageURLs = new Set(
      selectedSubLineItem &&
        selectedSubLineItem.options.map(option => {
          const { category, imageId } = option;
          const optionParams = { ...prefetchParams };
          if (imageId) {
            optionParams[category] = imageId;
          }
          return this.paramsToImageURL(optionParams);
        })
    );

    return children({ imageURL, prefetchImageURLs });
  }
}

ConfiguratorImage.propTypes = {
  templateParams: arrayOf(
    shape({
      name: string,
      value: string
    })
  ),
  children: func.isRequired,
  optionsForImageUrl: array.isRequired,
  view: object.isRequired,
  selectedSubLineItem: object,
  glencoeURL: string.isRequired
};

ConfiguratorImage.defaultProps = {
  templateParams: []
};

const getView = (_, props) => props.view;

const getConfiguratorImageData = createCachedSelector(
  getConfiguratorViews,
  getConfiguratorSubLineItems,
  getView,
  getConfiguratorTemplateParams,
  getProjectBranding,
  (views, subLineItems, view, templateParams, branding) => ({
    templateParams,
    view: view || views[0],
    optionsForImageUrl: subLineItems
      .filter(sli => !sli.isOptional || sli.isActivated)
      .map(sli => {
        if (!sli.selectedOption?.isValidOption) {
          return sli.validOptions[0];
        }
        return sli.selectedOption;
      }),
    glencoeURL: branding.getGlencoeURL()
  })
)((state, props) => props.configuratorId);

const ConfiguratorImageContainer = connect(getConfiguratorImageData)(
  ConfiguratorImage
);
ConfiguratorImageContainer.propTypes = {
  configuratorId: string.isRequired,
  selection: object,
  view: object,
  selectedSubLineItem: object
};
export default ConfiguratorImageContainer;
